<template>
  <div>
    <checkbox-input v-if="termsOfServiceExplicit" checkbox-id="accept-tos" :input-name="inputName" :label="label"
                    :validation-errors="validationErrors" @change="changed" />
    <div v-else>
      <div class="mt-3 small-text">
        <input type="hidden" :name="inputName" value="1">
        <span v-html="label" />
      </div>
    </div>
  </div>
</template>

<script>
import CheckboxInput from './checkbox-input'

export default {
  components: { CheckboxInput },

  props: {
    inputName: {
      type: String,
      required: true
    },

    label: {
      type: String,
      required: true
    },

    termsOfServiceExplicit: {
      type: Boolean,
      required: true
    },

    validationErrors: {
      type: Array,
      required: false
    }
  },

  emits: ['changed'],

  mounted() {
    // If ToS consent is required implicitly we need to emit the changed event when component
    // is just loaded so the parent is notified and the value is set on the model
    if (!this.termsOfServiceExplicit) {
      this.changed(true)
    }
  },

  methods: {
    changed(value) {
      this.$emit('changed', value)
    }
  }
}
</script>
